import { alpha, Box } from '@mui/material';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

import { MobileCaption } from '../Typography';

export type StatusChipType =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'assigned'
  | 'reviewed'
  | 'due'
  | 'default';

const TYPE_COLORS: Record<StatusChipType, string> = {
  success: BASE_COLORS.green,
  warning: BASE_COLORS.yellow,
  error: BASE_COLORS.red,
  info: BASE_COLORS.blue,
  default: BASE_COLORS.gray,
  assigned: BASE_COLORS.teal,
  reviewed: BASE_COLORS.darkGreen,
  due: BASE_COLORS.burgundy,
};

export const getStatusChipColor = (type: StatusChipType): string =>
  TYPE_COLORS[type] ?? TYPE_COLORS.default;

export interface StatusChipProps {
  text: string;
  type: StatusChipType;
}

const StatusChip: React.FC<StatusChipProps> = ({ text, type }) => {
  const color = TYPE_COLORS[type] ?? TYPE_COLORS.default;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: alpha(color, 0.2),
        color: color,
        whiteSpace: 'nowrap',
      }}
    >
      <MobileCaption
        component="span"
        sx={{
          fontWeight: 600,
          fontSize: '0.6875rem',
          lineHeight: 1.2,
          color: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        {text}
      </MobileCaption>
    </Box>
  );
};

export default StatusChip;
